import { useMemo } from 'react'
import type { AppGraph, AppGraphNodeType } from '../types'
import { useStudioLocale } from '@/i18n'

export interface StatsPanelProps {
  graph: AppGraph
}

const TYPES: AppGraphNodeType[] = [
  'app',
  'page',
  'block',
  'atom',
  'flow',
  'stateVar',
  'datasource',
]

export function StatsPanel({ graph }: StatsPanelProps) {
  const { strings } = useStudioLocale()
  const copy = strings.appMap
  const counts = useMemo(() => {
    const c: Partial<Record<AppGraphNodeType, number>> = {}
    for (const n of graph.nodes) c[n.type] = (c[n.type] ?? 0) + 1
    return c
  }, [graph])

  return (
    <section className="border-b border-border/40 px-3 py-3" aria-labelledby="stats-heading">
      <h3 id="stats-heading" className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {copy.stats.title}
      </h3>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
        {TYPES.map((t) => (
          <div key={t} className="flex items-center justify-between">
            <dt className="text-muted-foreground">{copy.nodeTypes[t]}</dt>
            <dd className="font-mono font-medium text-foreground">{counts[t] ?? 0}</dd>
          </div>
        ))}
        <div className="col-span-2 mt-1 flex items-center justify-between border-t border-border/40 pt-1">
          <dt className="text-muted-foreground">{copy.stats.edges}</dt>
          <dd className="font-mono font-medium text-foreground">{graph.edges.length}</dd>
        </div>
      </dl>
    </section>
  )
}
